import { KNOWN_ERROR_CODES } from './constants';

export const UNKNOWN_ERROR_MESSAGE = 'Oops! We have encountered an unknown error, please contact support.';

export const throwUnknownError = () => {
  throw Error(UNKNOWN_ERROR_MESSAGE);
};

export class KnownError extends Error {
  public code: string;

  constructor(message: string, code: string) {
    super(message);

    this.code = code;
  }
}

export const evaluateResponseErrorCode = (response: { errorCode?: string }) => {
  if ('errorCode' in response) {
    throw response.errorCode && response.errorCode in KNOWN_ERROR_CODES
      ? new KnownError(KNOWN_ERROR_CODES[response.errorCode], response.errorCode)
      : Error(UNKNOWN_ERROR_MESSAGE);
  }
};

export const getApiError = (error: unknown) => {
  if (error instanceof KnownError) {
    return error;
  }

  return Error(UNKNOWN_ERROR_MESSAGE);
};
